import React from 'react';
import StaffScanGate from '@/components/StaffScanGate';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const FlexiBundleReceiptEntry = () => {
  return (
    <StaffScanGate stationName="Flexi — Bundle Receipt">
    <SectionBundleReceiptEntry
      sectionName="Flexi"
      sectionDisplayName="Flexi Section"
      backRoute="/sections/flexi"
    />
    </StaffScanGate>
  );
};

export default FlexiBundleReceiptEntry;
